var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5808 17.2251C23.5458 13.7075 26.4493 12.0204 26.5791 11.9352C24.9473 9.54927 22.405 9.2219 21.5002 9.18464C19.3384 8.96507 17.2799 10.458 16.1832 10.458C15.0887 10.458 13.3942 9.21682 11.6016 9.24843C9.24333 9.28342 7.06965 10.62 5.8561 12.731C3.40698 16.9796 5.22957 23.276 7.61604 26.7242C8.78274 28.4096 10.1741 30.3061 11.9995 30.2367C13.7589 30.1673 14.4227 29.0988 16.5495 29.0988C18.6763 29.0988 19.2735 30.2367 21.1345 30.2011C23.0265 30.1667 24.2259 28.4835 25.383 26.7913C26.7225 24.8333 27.2739 22.9373 27.3066 22.8414C27.2654 22.8222 23.6186 21.4252 23.5808 17.2251Z",
    fill: "#4D0B0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.084 6.90258C21.0521 5.7274 21.7079 4.09447 21.5296 2.46887C20.1326 2.52532 18.4415 3.39738 17.4385 4.57142C16.5399 5.61339 15.7542 7.27229 15.9647 8.86853C17.5232 8.98932 19.1126 8.07549 20.084 6.90258Z",
    fill: "#4D0B0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.da9dc95aa48f7cd7d428214bd3dcd886.svg";
export { ForwardRef as ReactComponent };